var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { mediaApi } from '@sitecore-jss/sitecore-jss/media';
import PropTypes from 'prop-types';
import React from 'react';
import { getEEMarkup, withFieldMetadata, SitecoreContextReactContext, } from '@sitecore-jss/sitecore-jss-react';
import Image from 'next/image';
import { withEmptyFieldEditingComponent } from '@sitecore-jss/sitecore-jss-react';
import { DefaultEmptyFieldEditingComponentImage } from '@sitecore-jss/sitecore-jss-react';
import { isFieldValueEmpty, LayoutServicePageState } from '@sitecore-jss/sitecore-jss/layout';
export const NextImage = withFieldMetadata(withEmptyFieldEditingComponent((_a) => {
    var _b;
    var { editable = true, imageParams, field, mediaUrlPrefix, fill, priority } = _a, otherProps = __rest(_a, ["editable", "imageParams", "field", "mediaUrlPrefix", "fill", "priority"]);
    const sitecoreContext = React.useContext(SitecoreContextReactContext);
    // next handles src and we use a custom loader,
    // throw error if these are present
    if (otherProps.src) {
        throw new Error('Detected src prop. If you wish to use src, use next/image directly.');
    }
    const dynamicMedia = field;
    if (!field || (!dynamicMedia.editable && isFieldValueEmpty(dynamicMedia))) {
        return null;
    }
    const imageField = dynamicMedia;
    // we likely have an experience editor value, should be a string
    if (editable && imageField.editable) {
        return getEEMarkup(imageField, imageParams, mediaUrlPrefix, otherProps);
    }
    // some wise-guy/gal is passing in a 'raw' image object value
    const img = dynamicMedia.src
        ? field
        : dynamicMedia.value;
    if (!img) {
        return null;
    }
    // disable image optimization for Edit and Preview, but preserve original value if true
    const unoptimized = otherProps.unoptimized ||
        ((_b = sitecoreContext.context) === null || _b === void 0 ? void 0 : _b.pageState) !== LayoutServicePageState.Normal;
    const attrs = Object.assign(Object.assign(Object.assign({}, img), otherProps), { fill,
        priority, src: mediaApi.updateImageUrl(img.src, imageParams, mediaUrlPrefix), unoptimized });
    const imageProps = Object.assign(Object.assign({}, attrs), { 
        // force replace /media with /jssmedia in src since we _know_ we will be adding a 'mw' query string parameter
        // this is required for Sitecore media API resizing to work properly
        src: mediaApi.replaceMediaUrlPrefix(attrs.src, mediaUrlPrefix) });
    // Exclude `width`, `height` in case image is responsive, `fill` is used
    if (imageProps.fill) {
        delete imageProps.width;
        delete imageProps.height;
    }
    if (attrs) {
        return React.createElement(Image, Object.assign({ alt: "" }, imageProps));
    }
    return null; // we can't handle the truth
}, { defaultEmptyFieldEditingComponent: DefaultEmptyFieldEditingComponentImage }));
NextImage.propTypes = {
    field: PropTypes.oneOfType([
        PropTypes.shape({
            src: PropTypes.string.isRequired,
        }),
        PropTypes.shape({
            value: PropTypes.object,
            editable: PropTypes.string,
        }),
    ]),
    editable: PropTypes.bool,
    mediaUrlPrefix: PropTypes.instanceOf(RegExp),
    imageParams: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.number.isRequired, PropTypes.string.isRequired]).isRequired),
    emptyFieldEditingComponent: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.func,
    ]),
};
NextImage.displayName = 'NextImage';
